module.exports = __webpack_public_path__ + "assets/img/icon_update.36e15c4d.svg";